import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-79a21452"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "me-3" }
const _hoisted_4 = {
  key: 2,
  class: "badge bg-secondary-soft",
  style: {"font-size":"0.8rem"}
}
const _hoisted_5 = { class: "text-muted mt-2" }
const _hoisted_6 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = {
  key: 1,
  class: "row align-items-center"
}
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "nav nav-tabs nav-overflow header-tabs" }
const _hoisted_11 = ["onClick"]


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    title: {},
    subtitle: {},
    btnLabel: {},
    btnLink: {},
    btnIcon: {},
    tabs: {},
    iconClass: {},
    headerClass: {},
    headerBodyClass: {},
    totalCount: { default: null },
    isSubHeader: { type: Boolean, default: true }
  },
  emits: ["btnAction", "tabClicked"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const handleBtnAction = () => {
  emit("btnAction");
};

const handleTabClicked = (tab: any) => {
  emit("tabClicked", tab);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header mt-md-5", _ctx.headerClass])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["header-body", _ctx.headerBodyClass])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", {
            class: _normalizeClass(["text-pagetitle d-flex align-items-center", { 'header-subtitle-custom': _ctx.isSubHeader }])
          }, [
            (_ctx.iconClass)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass([_ctx.iconClass, "me-3"])
                }, null, 2))
              : _createCommentVNode("", true),
            (_ctx.$slots.iconImage)
              ? _renderSlot(_ctx.$slots, "iconImage", { key: 1 })
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
            (_ctx.totalCount !== null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.totalCount), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.subtitle), 1)
        ]),
        (_ctx.btnLabel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.btnLink)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: _ctx.btnLink,
                    class: "btn btn-secondary lift"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.btnIcon)
                        ? (_openBlock(), _createElementBlock("i", {
                            key: 0,
                            class: _normalizeClass([_ctx.btnIcon, "me-1"])
                          }, null, 2))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.btnLabel), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleBtnAction())),
                    class: "btn btn-secondary lift"
                  }, [
                    (_ctx.btnIcon)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass([_ctx.btnIcon, "me-1"])
                        }, null, 2))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.btnLabel), 1)
                  ]))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "button")
        ])
      ]),
      (_ctx.$slots.content)
        ? _renderSlot(_ctx.$slots, "content", { key: 0 })
        : _createCommentVNode("", true),
      (_ctx.tabs)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("ul", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "nav-item",
                    key: index
                  }, [
                    _createElementVNode("a", {
                      href: "",
                      onClick: _withModifiers(($event: any) => (handleTabClicked(item)), ["prevent"]),
                      class: _normalizeClass(["nav-link text-subtitle", { active: item.active }])
                    }, _toDisplayString(item.value), 11, _hoisted_11)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})